import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-term-services',
  templateUrl: './term-services.component.html',
  styleUrls: ['./term-services.component.scss']
})
export class TermServicesComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
    // this.titleService.setTitle('Terms of Services - Trinka');
    // this.metaTagService.updateTag({ name: 'description', content: 'Trinka’s free english grammar checker & writing app that helps every person and organization to communicate flawlessly.' });
    // this.metaTagService.updateTag({ name: 'keywords', content: 'check grammar mistake online, grammar checker for essay, grammar fixer, check grammar for free' });
    // this.metaTagService.updateTag({ property: 'og:title', content: 'Free Writing Tool & Grammar Checker - Trinka' });
    // this.metaTagService.updateTag({ property: 'og:description', content: 'With Trinka, enhances the tone, delivery, and phrasing of your writing according to academic publication standards. Start for free!' });
    // this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/termsofservices' });
    // this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    // this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/termsofservices' });
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }

}
